module.exports = __webpack_public_path__ + "img/hj-bg5.e517c1e0.jpg";